import React, { useState } from "react";
import axios from "axios";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalBody,
} from "@chakra-ui/modal";
import Card from "components/card";
import { Button } from '@chakra-ui/react';

const UpdateApiStatusConfirmModal: React.FC<{
    details: any;
    mode: "merchant" | "subaccount";
    statusToUpdate: string;
    isOpen: boolean;
    onClose(): void;
    triggerReload(): void;
    setSwalProps: any;
}> = ({ isOpen, statusToUpdate, onClose, triggerReload, details, mode, setSwalProps }) => {

    const [isProcessing, setIsProcessing] = useState<boolean>(false);

    const closeModal = async () => {
        onClose();
    };

    const handleSubmit = async () => {
        try {
            const postData = {
                ...(mode === "merchant"
                    ? { id: details.id, merchant_name: details.name }
                    : { subaccount_id: details.id, subaccount_name: details.suba_name }),
                is_active: statusToUpdate,
                auth1: details.auth1,
                username: localStorage.getItem("username"),
                userRole: localStorage.getItem("userRole")
            };

            setIsProcessing(true);
            await axios.post(process.env.REACT_APP_API_URL + `/api/${localStorage.getItem("userRole").toLowerCase()}/subaccount/action/update-api-status`,
                postData
            ).then(function (response) {
                if (response && response.data?.status === 'ok') {
                    closeModal();
                    setSwalProps({
                        show: true,
                        icon: "success",
                        title: "Success",
                        html: `${mode === "merchant" ? "Merchant" : "Subaccount"} API status has been ${statusToUpdate === "no" ? "deactivated" : "activated"}`,
                        showConfirmButton: true,
                        didClose: async () => {
                            setSwalProps({});
                            triggerReload();
                            setIsProcessing(false);
                        },
                    });
                } else {
                    closeModal();
                    setIsProcessing(false);
                    setSwalProps({
                        show: true,
                        icon: "error",
                        title: "Oops!",
                        html: response.data.message,
                        showConfirmButton: true,
                        didClose: () => {
                            setSwalProps({});
                        },
                    });
                }
            }).catch(function (error) {
                closeModal();
                setIsProcessing(false);
                setSwalProps({
                    show: true,
                    icon: "error",
                    title: "Oops!",
                    html: error.response.data.message,
                    showConfirmButton: true,
                    didClose: () => {
                        setSwalProps({});
                    },
                });
            });
        } catch (error) {
            closeModal();
            console.error("Error update status", error);
            setSwalProps({
                show: true,
                icon: "error",
                title: "Oops!",
                html: "Something went wrong, please try again later.",
                showConfirmButton: true,
                didClose: () => {
                    setSwalProps({});
                },
            });
            return false;
        }
    };

    return (
        <>
            {details &&
                <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
                    <ModalOverlay className="bg-[#000] !opacity-30" />
                    <ModalContent className="!z-[1002] !m-auto !w-max min-w-[350px] !max-w-[85%] md:top-[12vh]">
                        <ModalBody className="!text-navy-700">
                            <Card extra="px-[30px] pt-[35px] pb-[40px] max-w-[650px] flex flex-col !z-[1004]">
                                <h1 className="mb-[20px] text-2xl font-bold">Update {mode === "merchant" ? "Merchant" : "Subaccount"} API Status Confirmation</h1>
                                <div className="mb-[20px text-sm">
                                    <div className="mb-8">
                                        You're about to {statusToUpdate === "no" ? "deactivate" : "activate"} the current {mode === "merchant" ? "merchant" : "subaccount"} API status.
                                    </div>
                                </div>
                                <div className="flex gap-2 justify-end">
                                    <Button
                                        onClick={() => closeModal()}
                                        isDisabled={isProcessing}
                                        className="btn btn-default"
                                    >
                                        Close
                                    </Button>
                                    <Button
                                        onClick={() => handleSubmit()}
                                        isLoading={isProcessing}
                                        loadingText='Processing...'
                                        className={statusToUpdate === "no" ? "btn text-white bg-red-600 hover:bg-red-500" : "btn btn-primary"}>
                                        {statusToUpdate === "no" ? "Deactivate" : "Activate"}
                                    </Button>
                                </div>
                            </Card>
                        </ModalBody>
                    </ModalContent>
                </Modal>
            }
        </>
    );
};

export default UpdateApiStatusConfirmModal;
